import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';
import {
  clearGuestSession,
  getOrCreateGuestId,
  subscriptionIsActive,
  readStoredSubscription
} from '../utils/guestSession';
import { trackEvent, Events } from '../utils/webviewBridge';

const AuthContext = createContext(null);

/** @deprecated use guestId from context */
export const getStoredUserToken = () => '';

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [guestId] = useState(() => getOrCreateGuestId());

  const user = useMemo(
    () => ({
      id: guestId,
      guest: true,
      email: null,
      hasAccess: subscriptionIsActive(),
      subscription: readStoredSubscription()
    }),
    [guestId]
  );

  const logout = useCallback(() => {
    trackEvent(Events.SESSION_RESET);
    clearGuestSession({ keepGuestId: true });
    window.location.href = '/';
  }, []);

  const value = useMemo(
    () => ({
      token: null,
      guestId,
      user,
      booting: false,
      isAuthenticated: true,
      hasAccess: subscriptionIsActive(),
      logout,
      getGuestId: getOrCreateGuestId,
      getAuthHeader: () => ({ 'X-Guest-Id': guestId })
    }),
    [guestId, user, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
